<script>
import { SeasonCardSmallElementMixin } from "%/dynamic-component-editor/standard-components/season-card-small/season-card-small-element-mixin";
import BaseButtonElement
  from "%/dynamic-component-editor/standard-elements/button-element/BaseButtonElement.vue";

export default {
  name: "SeasonButton",
  elementPanelSettings: {
    displayName: "Go To Season Button",
    elementGroup: "season",
  },
  extends: BaseButtonElement,
  mixins: [SeasonCardSmallElementMixin],
  methods: {
    handleButtonClick() {
      const showId = this.entity.show?.pk?.id;
      const seasonId = this.entity.id;

      window.location.href = `${this.links.web}/show/${showId}/season/${seasonId}`;
    },
  },
};
</script>
